import React from 'react';
import './Services.css';

function Services({ language }) {
  const services = [
    {
      icon: 'fa-home',
      title: 'Home Buying',
      description: 'Expert guidance through the entire home buying process, from search to closing.'
    },
    {
      icon: 'fa-sign',
      title: 'Home Selling',
      description: 'Strategic marketing and skilled negotiation to sell your property quickly.'
    },
    {
      icon: 'fa-chart-line',
      title: 'Investment Properties',
      description: 'Identifying high-potential investment opportunities and market analysis.'
    },
    {
      icon: 'fa-chart-line',
      title: 'Rental Properties',
      description: 'Management of the rental and lease of properties.'
    },
    {
      icon: 'fa-plane',
      title: 'Relocation Services',
      description: 'Seamless support for clients moving to Edmonton — remote viewings, neighbourhood guidance, and bilingual assistance.'
    },
    {
      icon: 'fa-key',
      title: 'First-Time Buyer Guidance',
      description: 'Step-by-step support through your first home purchase, from mortgage pre-approval to closing day.'
    }
  ];

  return (
    <section id="services">
      <div className="container">
        <div className="section-title-center">
          <h2>My Services</h2>
          <p>Comprehensive real estate solutions tailored to your needs</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <i className={`fas ${service.icon}`}></i>
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
